const initialState = {
  success: false,
  loading: false,
  error: null,
  ETOList: {
    data: null,
    loading: false,
    error: null,
  },
  addETOResponse: {
    data: null,
    loading: false,
    error: null,
  },
  EtoOrTiDetails: {
    data: null,
    loading: false,
    error: null,
  },
  etoOfDistrict: {
    data: null,
    loading: false,
    error: null,
  },
  updateETOResponse: {
    data: null,
    loading: false,
    error: null,
  },
};

const ETOReducer = (
  state = initialState,
  { obj, type, error, payload, data }
) => {
  switch (type) {
    case "RESET_ETO":
      return initialState;

    case "RESET_UPDATE_ETO":
      return {
        ...state,
        updateETOResponse: {
          data: null,
          loading: false,
          error: null,
        },
      };

    case "UPDATE_ETO":
      return {
        ...state,
        updateETOResponse: {
          ...state.updateETOResponse,
          loading: true,
        },
      };

    case "UPDATE_ETO_SUCCESS":
      return {
        ...state,
        updateETOResponse: {
          ...state.updateETOResponse,
          data,
          loading: false,
        },
      };

    case "UPDATE_ETO_FAIL":
      return {
        ...state,
        updateETOResponse: {
          ...state.updateETOResponse,
          error,
          loading: false,
        },
      };

    case "GET_ETO_OF_DISTRICT":
      return {
        ...state,
        etoOfDistrict: {
          ...state.etoOfDistrict,
          loading: true,
        },
      };

    case "GET_ETO_OF_DISTRICT_SUCCESS":
      return {
        ...state,
        etoOfDistrict: {
          ...state.etoOfDistrict,
          data,
          loading: false,
        },
      };

    case "GET_ETO_OF_DISTRICT_FAIL":
      return {
        ...state,
        etoOfDistrict: {
          ...state.etoOfDistrict,
          error,
          loading: false,
        },
      };

    case "GET_ALL_ETO":
      return {
        ...state,
        ETOList: {
          ...state.ETOList,
          loading: true,
        },
      };

    case "GET_ALL_ETO_SUCCESS":
      return {
        ...state,
        ETOList: {
          ...state.ETOList,
          data,
          loading: false,
        },
      };

    case "GET_ALL_ETO_FAIL":
      return {
        ...state,
        ETOList: {
          ...state.ETOList,
          error,
          loading: false,
        },
      };

    case "ADD_ETO":
      return {
        ...state,
        addETOResponse: {
          ...state.addETOResponse,
          loading: true,
        },
      };

    case "ADD_ETO_SUCCESS":
      return {
        ...state,
        addETOResponse: {
          ...state.addETOResponse,
          data,
          loading: false,
        },
      };

    case "ADD_ETO_FAIL":
      return {
        ...state,
        addETOResponse: {
          ...state.addETOResponse,
          error,
          loading: false,
        },
      };

    case "RESET_ADD_ETO":
      return {
        ...state,
        addETOResponse: {
          ...state.addETOResponse,
          data: null,
          loading: false,
          error: null,
        },
      };

    case "GET_ETO_OR_TI_DETAILS":
      return {
        ...state,
        EtoOrTiDetails: {
          ...state.EtoOrTiDetails,
          loading: true,
        },
      };

    case "GET_ETO_OR_TI_DETAILS_SUCCESS":
      return {
        ...state,
        EtoOrTiDetails: {
          ...state.EtoOrTiDetails,
          data,
          loading: false,
        },
      };

    case "GET_ETO_OR_TI_DETAILS_FAIL":
      return {
        ...state,
        EtoOrTiDetails: {
          ...state.EtoOrTiDetails,
          error,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default ETOReducer;
